import * as appDebugging from "./DebugLogging";
import * as appUtils from "./AppUtils";

export const appConfig = appUtils.appEnum.createEnum([
    "isUserLogin",
    "isUserAdmin",
    "isShowLoadingScreen"
]);

export const appFunc = {
    ...appDebugging,
    ...appUtils,
};